<template lang="pug">
  .div
    .dialog-container(id="DialogClonePlayitems-container" v-if='this.$store.state.Medium.playitems_selected_right.length > 0')
      h4 {{$t('Clone')}}
        span &nbsp;
        font-awesome-icon(icon="copy")
      hr.header
      el-row
        el-col.col-left(:span="10")
          h4 {{$t('Playitems')}}:
          hr.header
          ShortMediaList(id="DialogClonePlayitems-playitemList" ref='childrenList', :items='this.$store.state.Medium.playitems_selected_right.map(pi => pi.Medium)', :showThumbs="true", :showMediaIcons="true")
        el-col.col-middle(:span="4")
          el-button.confirm(id="DialogClonePlayitems-cloneButton" v-if='!saving', type="success", :disabled='!somePlayItemsSelected', @click="clonePlayitems()", circle)
            font-awesome-icon.linker-icon(icon="copy")
            | &nbsp; {{$t("Clone")}} &nbsp;
          el-button.confirm.spinner(v-if='saving', type="primary", circle)
            font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
            .spinner-text {{ percentDone }}%
        el-col.col-right(:span="10")
          .playlist
            h4 {{ $t('Into') }} {{ playList.name }}
            hr.header
            el-form(
              @submit='clonePlayitems()',
              @keyup.enter='clonePlayitems()',
              v-on:submit.native.prevent="clonePlayitems()"
            )
              el-form-item(:label="$t('Number of copies')")
                el-input-number(id="DialogClonePlayitems-numOfCopiesInput" v-model="numberOfCopies")
              el-form-item(:label="$t('Copy time restrictions')")
                el-checkbox(id="DialogClonePlayitems-timeRestrictionsCheckbox" v-model="copyTimeRestrictions")
              el-form-item(:label="$t('Copy other restrictions')")
                el-checkbox(id="DialogClonePlayitems-otherRestrictionsCheckbox" v-model="copyOtherRestrictions")
            //- for future use (selecting clone place/order)
            //- ShortMediaList(ref='childrenList', :items='playListWithContentSimple.PlayListItems.map(pli => pli.Medium)', :showThumbs="true", :showMediaIcons="true")
</template>

<script>
import Vue from 'vue'
import ShortMediaList from '../Common/ShortMediaList'

export default {
  props: ['choice'],
  components: {
    ShortMediaList
  },
  mounted () {
    if (this.$refs.input_name) this.$refs.input_name.focus()
  },
  updated () {
    if (this.$refs.input_name) this.$refs.input_name.focus()
  },
  async created () {
    this.playList = this.$store.state.Medium.media_list.find(m => m.id === this.$store.state.Medium.playitems_selected_right[0].PlayList)
    // for future use (selecting clone place/order)
    this.playListWithContentSimple = await this.$store.dispatch('Medium/getPlaylistContentSimple', this.playList)
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: 0,
      playList: undefined,
      playListWithContentSimple: undefined,
      numberOfCopies: 1,
      copyTimeRestrictions: false,
      copyOtherRestrictions: false,
      layoutData: {
        playListLayoutWidth: 1920,
        playListLayoutHeight: 1080,
        type: 'PlayListLayout'
      }
    }
  },
  methods: {
    async clonePlayitems () {
      this.$emit('linkerJobStarted')
      this.saving = true
      const toBeDoneOperations = this.$store.state.Medium.playitems_selected_right.length * this.numberOfCopies
      let doneSoFarOperations = 0
      try {
        for (let index = 0; index < this.numberOfCopies; index++) {
          for (const playitemCloned of this.$store.state.Medium.playitems_selected_right) {
            const playitemCreated = await this.$store.dispatch('Medium/assignMediumToPlaylist', [this.playListWithContentSimple.id, playitemCloned.Medium.id])
            if (this.copyTimeRestrictions) {
              for (const restriction of this.__prepareTimeRestrictionData(playitemCloned.PlayListItem_DateRestrictions, playitemCreated.id)) {
                await Vue.axios.post(`PlayListItem_DateRestriction/`, restriction)
              }
              for (const restriction of this.__prepareTimeRestrictionData(playitemCloned.PlayListItem_DaytimeRestrictions, playitemCreated.id)) {
                await Vue.axios.post(`PlayListItem_DaytimeRestriction/`, restriction)
              }
            }
            if (this.copyOtherRestrictions) {
              await Vue.axios.patch(`PlayListItem/${playitemCreated.id}`, this.__prepareOtherRestrictionData(playitemCloned))
            }
            doneSoFarOperations++
            this.percentDone = parseInt(doneSoFarOperations / toBeDoneOperations * 100)
          }
        }
      } finally {
        this.$emit('linkerJobDone')
      }
      this.saving = false
      this.percentDone = 0
    },
    __prepareTimeRestrictionData (array, playitemId) {
      return array.map((item) => {
        delete item.id
        delete item.createdAt
        delete item.updatedAt
        delete item.userId
        delete item.PlayListItem
        item.PlayListItem = playitemId
        return item
      })
    },
    __prepareOtherRestrictionData (playitem) {
      let { anchorX, anchorY, broadcastSynchronize, extensionConfig, height, listenSynchronize, objectFit, objectPosition, objectRotation, onEndBehaviour, pausePlayOtherContent, playDurationMs, playForbiddenInMedia, playOffsetMs, playOnlyInMedia, width } = playitem
      return { anchorX, anchorY, broadcastSynchronize, extensionConfig, height, listenSynchronize, objectFit, objectPosition, objectRotation, onEndBehaviour, pausePlayOtherContent, playDurationMs, playForbiddenInMedia, playOffsetMs, playOnlyInMedia, width }
    }
  },
  computed: {
    somePlayItemsSelected () {
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogClonePlayitems.vue